<template>
  <div>
    <ApplicationHeaderPcTablet
      :menuConfig="menuConfig"
      :headerClass="headerPcClass"
      :blocMarqueConfig="blocMarqueConfig"
      :logoConfig="logoConfig"
      :customConnectedButtons="customConnectedButtons"
      :disconnectConfig="disconnectConfig"
      :profilConfig="profilConfig"
      :searchConfig="searchConfig"
      :connectConfig="connectConfig"
      v-on="$listeners"
      @disconnect="disconnect"
      @connect="connect"
    >
      <slot name="customBlocLogotype"></slot>
    </ApplicationHeaderPcTablet>
    <ApplicationHeaderMobile
      :menuConfig="menuConfig"
      :headerClass="headerMobileClass"
      :blocMarqueConfig="blocMarqueConfig"
      :logoConfig="logoConfig"
      :customConnectedButtons="customConnectedButtons"
      :disconnectConfig="disconnectConfig"
      :profilConfig="profilConfig"
      :searchConfig="searchConfig"
      :connectConfig="connectConfig"
      v-on="$listeners"
      @disconnect="disconnect"
      @connect="connect"
    >
      <slot name="customBlocLogotype"></slot>
    </ApplicationHeaderMobile>
  </div>
</template>

      
<script>
import ApplicationHeaderConfig from "./ApplicationHeaderConfig";
import ApplicationMenuConfig from "@clir/ApplicationMenu/ApplicationMenuConfig";

import ApplicationHeaderPcTablet from "./ApplicationHeaderPcTablet";
import ApplicationHeaderMobile from "./ApplicationHeaderMobile";

/**
 * Composant de génération de l'entête général de l'application
 *
 *
 * @author <span><span class="fw-bold">Pascal Ouzeau</span><a class="ms-2" href="mailto:pascal.ouzeau@dgfip.finances.gouv.fr">pascal.ouzeau@dgfip.finances.gouv.fr</a></span>
 * @since Version 1.0
 * @version 1.2
 * @displayName ApplicationHeader
 */
export default {
  name: "ApplicationHeader",
  props: {
    config: { type: Object, default: () => ApplicationHeaderConfig },
    menuConfig: { type: Object, default: () => ApplicationMenuConfig }
  },
  computed: {
    headerPcClass() {
      return this.prefixStringKey(this.config, "headerClass", {
        prefix: "d-none d-md-block mt-0 ",
        defaut: "d-none d-md-block mt-0"
      });
    },
    headerMobileClass() {
      return this.prefixStringKey(this.config, "headerClass", {
        prefix: "navbar navbar-expand-lg d-block d-md-none mt-0 ",
        defaut: "navbar navbar-expand-lg bg-light d-block d-md-none mt-0"
      });
    },
    blocMarqueConfig() {
      return this.getKey(this.config, "blocMarque", {});
    },
    logoConfig() {
      return this.getKey(this.config, "logo", {});
    },
    customConnectedButtons() {
      return this.getKey(this.config, "customConnectedButtons", []);
    },
    disconnectConfig() {
      return this.getKey(this.config, "applicationDisconnector", {});
    },
    profilConfig() {
      return this.getKey(this.config, "applicationUser", {});
    },
    searchConfig() {
      return this.getKey(this.config, "applicationSearcher", {});
    },
    connectConfig() {
      return this.getKey(this.config, "applicationConnector", {});
    }
  },
  components: {
    ApplicationHeaderPcTablet,
    ApplicationHeaderMobile
  },
  methods: {
    async connect() {
      if (this.$router.currentRoute.name !== "Login")
        this.$router.push("/login");
    },
    async disconnect() {
      if (this.$store.getters["user/isAuthenticated"]) {
        try {
          await this.logout();
          if (this.$router.currentRoute.name !== "Accueil")
            this.$router.push({ path: "/" });
        } catch (e) {
          if (e.status === 403) {
            this.$router.push({ path: "/login" });
          }
        }
      } else {
        if (this.$router.currentRoute.name !== "Login")
          this.$router.push({ path: "/login" });
      }
    }
  }
};
</script>